import { render, staticRenderFns } from "./formsList.vue?vue&type=template&id=98025ca4"
import script from "./formsList.vue?vue&type=script&lang=js"
export * from "./formsList.vue?vue&type=script&lang=js"
import style0 from "./formsList.vue?vue&type=style&index=0&id=98025ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports